<div class="fuse-card auto-width mat-card mb-12 p-0">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
        class="dis-block p-10">
        <div *ngIf="isLoading" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
        <div *ngIf="!isLoading">

            <div *ngIf="this.absenteeismData && this.absenteeismData.length > 0">
            
                <div class="pl-8 pr-8" fxLayout="row" fxLayoutAlign="end center">
                    <button mat-icon-button class="fuse-widget-flip-button" aria-label="more"
                        (click)="openChartPopup()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <canvas baseChart [datasets]="absenteeismData" [labels]="chartService.monthLabels"
                [options]="chartOptions" legend="true" [type]="'line'">
            </canvas>
            </div>

            <div *ngIf="!this.absenteeismData || (this.absenteeismData && this.absenteeismData.length === 0)">
                <p>Sin datos de absentismo de la empresa seleccionada.</p>
            </div>

        </div>
    </div>
</div>